module.exports = __webpack_public_path__ + "static/img/pic4.1a31ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic4.png
// module id = 4FQm
// module chunks = 1